module.exports = __webpack_public_path__ + "static/media/sponsor.b94a93c0.jpg";